import React from "react";

const RadioButtonDefecto = ({ children, disabled, descripcion, nombre, valor, checked, referencia, selectRadio }) => {
    const classBase = `container-radio${((disabled) ? "-disabled" : "")} radio-margin`;

    return (
        <div className="row">
            <div className="col-xs-12 separator-radio-button-left">
                <div className={classBase} data-toggle="tooltip" data-placement="top" title={disabled ? /*"Valor no vigente actualmente - se desafectara del Producto al grabar"*/ null : null}>
                    <input
                        type="radio"
                        id={referencia}
                        name={nombre}
                        value={valor}
                        checked={checked}
                        disabled={disabled}
                        onChange={(event) => {
                            if (!disabled)
                                selectRadio(event.target.value)
                        }} />
                    <label
                        className="lbl-radio label-secondary"
                        htmlFor={referencia}>{descripcion}</label>
                </div>
            </div>

            <div className="col-xs-12">
                {children}
            </div>
        </div>
    );
}

export default RadioButtonDefecto;